import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/goalsSagas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { queryParams } from "../../utils/queryParams";
import { UploadGoals } from "./smartComponents/UploadGoals";
import DatePicker from "./smartComponents/DatePicker";
import ViewFilter from "./smartComponents/ViewFilter";
import TopGoals from "./smartComponents/TopGoals";
import SectionToggle from "../../components/sectionToggle/sectionToggle";
import { ModuleViewFilter } from "./smartComponents/ModuleViewFilter";
import GoalSection from "./smartComponents/GoalSection";
import KBLearnMore from "../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../constants/ilearnUrls";

export function getGoalValue(item) {
  const goal = item.goalValue;

  if (!goal || !isFinite(goal)) {
    return 0;
  }

  const percent = (item.currentVal / goal) * 100;

  return item.goalUsesPercent ? Math.round(percent) : percent;
}

export function getForecastValue(item) {
  const goal = item.goalValue;
  const value = item.currentValPacing;

  if (!goal || !isFinite(goal)) {
    return 0;
  }

  const percent = (value / goal) * 100;

  return item.goalUsesPercent ? Math.round(percent) : percent;
}

const GoalsModule = (props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.goals.isLoading);
  const moduleView = useSelector((state) => state.goals.selectedModuleView.id);
  const { short_url, can_modify_goals, singleLocation } = useSelector(
    (state) => state.goals.currentUser
  );
  const isCurrentMonth = useSelector((state) => state.goals.isCurrentMonth);

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  return (
    <div className="goals-module">
      <SectionToggle
        maxHeight="auto"
        autoHeight
        title="Goals by"
        hideToggle
        isLoading={isLoading}
        learnMore={
          <>
            <ModuleViewFilter />
            <KBLearnMore
              title={moduleView === "staff" ? "Goals by Staff" : "Goals by Store"}
              description={
                moduleView === "staff"
                  ? "This report shows goal progress by staff member, giving you visibility into individual performance and contribution toward team objectives. These insights help you guide coaching, recognize top performers, and support staff who may need additional direction."
                  : "This report shows each store's performance against key business goals for your selected timeframe. These insights help you identify which locations are meeting, exceeding, or falling behind targets so you can make informed strategic adjustments."
              }
              kbUrl={
                moduleView === "staff"
                  ? ILEARN_URLS.goals.goalsByStaff
                  : ILEARN_URLS.goals.goalsByStore
              }
            />
          </>
        }
        content={
          <div>
            <div className="page-controls">
              <div className="page-controls__filters">
                {(!singleLocation || moduleView === "staff") && (
                  <div className="page-controls__filter page-controls__filter--view ">
                    <p>View</p>
                    <ViewFilter />
                  </div>
                )}

                <div className="page-controls__filter page-controls__filter--date">
                  <p>Date</p>
                  <DatePicker />
                </div>
              </div>
              {isCurrentMonth && moduleView !== "staff" && (
                <div className="page-controls__actions">
                  <a
                    className="download-btn"
                    title="Export to Excel"
                    href={`${queryParams.apiVersion}/goals/export?short_url=${short_url}`}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "var(--color-icons-bg)",
                        marginLeft: "8px",
                        verticalAlign: "bottom"
                      }}
                      width={15}
                      height={15}
                      icon={faDownload}
                    />
                  </a>
                  {can_modify_goals && <UploadGoals />}
                </div>
              )}
              {isCurrentMonth && moduleView === "staff" && (
                <div className="page-controls__actions">
                  <a
                    className="download-btn"
                    title="Export to Excel"
                    href={`${queryParams.apiVersion}/staff_goals/export?short_url=${short_url}`}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "var(--color-icons-bg)",
                        marginLeft: "8px",
                        verticalAlign: "bottom"
                      }}
                      width={15}
                      height={15}
                      icon={faDownload}
                    />
                  </a>
                  {can_modify_goals && <UploadGoals type="staff" />}
                </div>
              )}
            </div>

            <div>
              <TopGoals />
              {moduleView === "staff" && (
                <>
                  <GoalSection goalType="revenue" defaultTitle="Revenue" zIndex={10} />
                  <GoalSection goalType="attendance" defaultTitle="Attendance" zIndex={9} />
                  <GoalSection goalType="retention" defaultTitle="Retention" zIndex={8} />
                </>
              )}

              {moduleView === "store" && (
                <>
                  <GoalSection goalType="attendance" defaultTitle="Attendance" zIndex={10} />
                  <GoalSection goalType="memberships" defaultTitle="Memberships" zIndex={9} />
                  <GoalSection goalType="revenue" defaultTitle="Revenue" zIndex={8} />
                  <GoalSection goalType="retention" defaultTitle="Retention" zIndex={7} />
                  <GoalSection goalType="daily_pulse" defaultTitle="Daily Pulse" zIndex={6} />
                </>
              )}
            </div>
          </div>
        }
      />
    </div>
  );
};

export default GoalsModule;
